/**
 * Typed live-service payloads for family screens.
 * Inputs: /api/live JSON. Outputs: weather line, FX rate, per-flight observations.
 */

import type { LiveObservation } from "@shared/schema.ts";

export type LivePayload = {
  weather?: LiveObservation | null;
  weatherNote?: string | null;
  fx?: LiveObservation | null;
  flights?: LiveObservation[];
  providers?: Array<{ id?: string; label: string; status: string; detail?: string }>;
};

export { weatherLine, type WeatherLine } from "@shared/weather-line.ts";

export function fxRate(obs: LiveObservation | null | undefined): { thbPerGbp: number; asOf: string | null } | null {
  const rates = (obs?.payload as { rates?: { THB?: number }; date?: string } | undefined);
  const thb = rates?.rates?.THB;
  if (!thb) return null;
  return { thbPerGbp: thb, asOf: rates?.date ?? obs?.observedAt ?? null };
}

export function flightObservation(flights: LiveObservation[] | undefined, flightId: string): LiveObservation | undefined {
  return flights?.find((row) => row.id === `flight-${flightId}` || row.subjectId?.includes(flightId));
}
